const subscription = {
    limit_exceeded: '您已达到订阅计划的限制。',
    get_plan_failed: '无法获取租户的订阅计划。',
    tenant_suspended: '租户已被暂停。 请联系您的管理员。',
};
export default Object.freeze(subscription);
